import { Note, Point } from '../inspection-image';
import { ImageMetadata } from './image-metadata';

/**
 * Soleil 用 ImageMetadata クラス。
 */
export class SoleilImageMetadata extends ImageMetadata {
  public mark?: number;
  public title: string;
  public tags: Array<string>;
  public titleSeq: string;
  public notes: Array<Note>;
  public changedImage?: number;
  public screenShot?: number;
  public frameMode?: number;
  public videoNorm?: number;
  public captureInstrument?: number;
  public ccuInstrument?: number;
  public scopeNumber: string;
  public scopeDiameter?: number;
  public scopeLength?: number;
  public scopeDate: string;
  public contrastCompensation?: number;
  public colorEnhance?: number;
  public gain?: number;
  public imageInvert?: number;
  public brightness?: number;
  public sharpness?: number;
  public exposure?: number;
  public printscreenInfo?: number;
  public imageFilter?: number;
  public noiseReduction?: number;
  public videoType?: number;
  public adapterType?: number;
  public adapterName: string;
  public setNumber: string;
  public zoomMode?: number;
  public zoomRatio: string;
  public fieldOfView?: number;
  public distortionExpresionType?: number;
  public distortionData?: number;
  public opticalCenterX?: number;
  public opticalCenterY?: number;
  public circleRadius?: number;
  public stereoAdapterDisplayMode?: number;
  public directAdapterDisplayMode?: number;
  public opticalAdapterType?: number;
  public scopeUnitSerial: string;
  public measurementMode?: number;
  public accuracyZ?: number;
  public scale?: number;
  public result?: number;
  public unit?: number;
  public subResCnt?: number;
  public subResult?: number;
  public subResUnit?: number;
  public defectType?: number;
  public defectLength1?: number;
  public defectLength2?: number;
  public referenceCnt?: number;
  public references: Array<Point>;
  public pointCnt?: number;
  public points: Array<Point>;
  public subpixResolution: Point;
  public subpixOfReferences: Array<Point>;
  public subpixOfPoints: Array<Point>;
  public measurementResultCnt?: number;
  public measurementResults: Array<number>;
  public measurementResultZ?: number;
  public offsetPoints: Array<number>;
  public offsetCnt?: number;
  public offsetMode?: number;
  public setupData: SoleilImageMetadataSetupDataDetail;
  public mainCPUFWVer: string;
  public grade?: number;
  public rerecord?: number;
  public scopeInfoType?: number;
  public referenceRightModify: Array<SoleilImageMetadataModify>;
  public pointRightModify: Array<SoleilImageMetadataModify>;
  public subpixOfReferenceRightModify: Array<SoleilImageMetadataModify>;
  public subpixOfPointRightModify: Array<SoleilImageMetadataModify>;
}

/**
 * Soleil 用 ImageMetadataSetupDataDetail クラス。
 */
export class SoleilImageMetadataSetupDataDetail {
  public stereoSWVer: string;
  public calibrationDate: string;
  public captureInstrument?: number;
  public ccuInstrument?: number;
  public videoNorm?: number;
  public scopeNumber: string;
  public scopeDate: string;
  public imageInvert?: number;
  public formatVer: string;
  public adapterName: string;
  public setNumber: string;
  public magnificationH?: number;
  public magnificationV?: number;
  public deviationH?: number;
  public deviationV?: number;
  public cutOutW?: number;
  public cutOutH?: number;
  public cutOutYShift?: number;
  public enp?: number;
  public nearPoint?: number;
  public farPoint?: number;
  public nearLimit?: number;
  public highAccuracyLimit?: number;
  public farLimit?: number;
  public jigSWVer: string;
  public focusL?: number;
  public focusR?: number;
  public normX?: number;
  public normY?: number;
  public clbCentLX?: number;
  public clbCentLY?: number;
  public clbCentRX?: number;
  public clbCentRY?: number;
  public optShiftLX?: number;
  public optShiftLY?: number;
  public optShiftRX?: number;
  public optShiftRY?: number;
  public mmPxlH?: number;
  public mmPxlV?: number;
  public olOrX?: number;
  public olOrY?: number;
  public olOrZ?: number;
  public optAngX?: number;
  public optAngY?: number;
  public optAngZ?: number;
  public firstDistCorrectionAL: Array<number>;
  public firstDistCorrectionBL: Array<number>;
  public firstDistCorrectionAR: Array<number>;
  public firstDistCorrectionBR: Array<number>;
  public opticalAxisMatrixA: Array<Array<number>>; // 2次元配列
  public secondDistCenterX?: number;
  public secondDistCenterY?: number;
  public secondDistType?: number;
  public secondDistA?: number;
  public secondDistB?: number;
  public secondDistC?: number;
  public adtAng?: number;
  public maskLineLPointCnt?: number;
  public maskLineLPoints: Array<Point>;
  public maskLineRPointCnt?: number;
  public maskLineRPoints: Array<Point>;
  public userScopeMagDataVersion?: number;
  public userScopeMag?: number;
  public userScopeMagDistCenterX?: number;
  public userScopeMagDistCenterY?: number;
  public userScopeMagDistCorrection: Array<number>;
  public userScopeMagEnabled?: number;
}

/**
 * Soleil 用 ImageMetadataModify クラス。
 */
export class SoleilImageMetadataModify {
  public x?: number;
  public y?: number;
  public mod?: number;
  public modify?: number;
}

export namespace SoleilImageMetadataDef {

  export enum MeasurementType {
    Invalid = 0,
    Distance = 1,
    PointToLine = 2,
    Lines = 3,
    Depth = 4,
    Area = 5,
    Profile = 6,
    Multi = 7,
    Offset = 8,
    Scalar = 9
  }

}
